export default "__VITE_ASSET__Bogg4nli__"